import {ApiClientInterface} from '../../models/api-client/models';
import {jobsApiClient} from './jobs';
import {ContactsApiClient} from './contacts';
import {ApplicantsApiClient} from './applicants';
import {UsersApiClient} from './users';

// create an instance of our main ApiClient that wraps the mock child clients
const apiMockClient: ApiClientInterface = {
  jobs: jobsApiClient,
  contacts: ContactsApiClient,
  applicants: ApplicantsApiClient,
  users: UsersApiClient,
};

export {apiMockClient};
